module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.e68987a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/AmwayIcons.eot?5v2gxx
// module id = Ez7d
// module chunks = 0